import { MdbRippleModule } from 'mdb-angular-ui-kit/ripple';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, HostListener, NO_ERRORS_SCHEMA } from '@angular/core';

@Component({
  standalone: true,
  schemas: [NO_ERRORS_SCHEMA],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MdbRippleModule],
  selector: 'app-faq-billing',
  templateUrl: './faq-billing.component.html',
  styleUrls: ['./faq-billing.component.scss'],
})
export class FaqBillingComponent  {
  accordianWithMDB: any = {};
  isLargeScreen: boolean = window.innerWidth >= 1440;

  @HostListener('window:resize')
  onResize() {
    this.isLargeScreen = window.innerWidth >= 1440;
  }

  constructor() {
    this.accordianWithMDB = {
      zero: false,
      one: false,
      two: false,
      three: false,
      four: false,
    };
  }

  closeNonActiveCollapse(name): void {
    const acc = this.accordianWithMDB;
    for (const element in acc) {
      if (element != name) {
        acc[element] = false;
      }
    }
    acc[name] = !acc[name];
  }

}
